<template>
    <div id="v-knowledge-wrap">
        <!-- 顶部栏 -->
        <div class="head">
            <dl>
                <dt>
                    <img class="logo" :src="$config.resource + 'dhl_logo.png'" alt="">
                </dt>
                <!-- 头像信息 -->
                <dd>
                    <div class="portrait">
                        <img class="pic" :src="user.head" alt="">
                    </div>
                    <p>{{user.company_name}}</p>
                    <div class="quit" @click="onQuit">
                        <img class="icon" :src="$config.resource + 'tc.png'" alt="">
                    </div>
                </dd>
            </dl>
        </div>
        <!-- 主要部分 -->
        <div class="main-box">
            <!-- 步骤 -->
            <div class="step">
                <img class="pic_bg" :src="$config.resource + 'db_bjt.png'" alt="">
                <div class="row_box">
                    <div class="row curr">
                        <div class="circle">1</div>
                        <p>知识产权调查表</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">2</div>
                        <p>信息安全调查表</p>
                    </div>
                    <div class="wire"></div>
                    <div class="row">
                        <div class="circle">3</div>
                        <p>附件</p>
                    </div>
                </div>
            </div>
            <!-- 知识产权调查表 -->
            <div class="alike">
                <div class="top_box">
                    <div class="pattern"></div>
                    <p>知识产权调查表</p>
                </div>
                <ul>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt design">供应产品/服务/技术名称：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="text" v-model="name" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt design">发明专利数量：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="invent" placeholder="没有则填0" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt design">著作权数量:</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="copyright" placeholder="没有则填0" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt design">实用新型专利数量:</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="practical" placeholder="没有则填0" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt design">其它：</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="other" placeholder="没有则填0" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt design">商标数量:</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="brand" placeholder="没有则填0" />
                        </div>
                    </li>
                    <li>
                        <div class="name">
                            <p>*</p>
                            <div class="tt design">外观专利数量:</div>
                        </div>
                        <div class="inp_unit">
                            <input class="inp" type="number" v-model="facade" placeholder="没有则填0" />
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 按钮 -->
            <div class="btn_box">
                <div class="btn gray" @click="onDown">下载知识产权调查表</div>
                <div class="btn gray" v-if="isType!=2">
                    <em>上传知识产权调查表</em>
                    <input 
                        class="uploadBtn" 
                        name="key" 
                        type="file" 
                        @change="uploadFile($event)" 
                        ref="inputer" 
                        accept=".pdf" 
                    />
                </div>
                <div class="btn gray" v-if="isType!=2" @click="onSave">保存草稿</div>
                <div class="btn gray" @click="onBack">上一步</div>
                <div class="btn red" v-if="isType!=2" @click="onSubmit">下一步</div>
                <div class="btn red" v-if="isType==2" @click="toViewPage('/safety',{type:2})">下一步</div>
            </div>
        </div>
    </div>
</template>
<script>
    import store from '../vuex/store.js';
    export default {
        data(){
            return{
                user:'',// 用户信息
                isType:'',// 1.提交下一步 2.详情下一步 3.重新提交

                name:'',// 供应产品/服务/技术名称
                invent:'',// 发明专利数量
                copyright:'',// 著作权数量
                practical:'',// 实用新型专利数量
                other:'',// 其它
                brand:'',// 商标数量
                facade:'',// 外观专利数量
            }
        },
        store,
        methods: {
            //页面跳转
            toViewPage($path,$query) {
                this.$jump.toViewPage(this,$path,$query)
            },
            // 下载知识产权调查表
            onDown(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.learningDown,
                    loading: true,
                    data: {
                        technical_name:that.name,// 供应产品/服务/技术名称
                        patents:that.invent,// 发明专利数量
                        copyrights_name:that.copyright,// 著作权数量
                        utility_patents:that.practical,// 实用新型专利数量
                        other_patents:that.other,// 其它
                        logo:that.brand,// 商标数量
                        design_patent:that.facade,// 外观专利数量
                    },
                    success(res) {
                       window.open(res.data.ip_inquiry)
                    }
                })
            },
            // 上传知识产权调查表
            onPut(){},
            // 保存草稿
            onSave(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.learning,
                    data: {
                        technical_name:that.name,// 供应产品/服务/技术名称
                        patents:that.invent,// 发明专利数量
                        copyrights_name:that.copyright,// 著作权数量
                        utility_patents:that.practical,// 实用新型专利数量
                        other_patents:that.other,// 其它
                        logo:that.brand,// 商标数量
                        design_patent:that.facade,// 外观专利数量
                        type:2,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                        })
                    }
                }) 
            },
            // 上一步
            onBack(){
                this.$router.go(-1);
            },
            // 获取保存草稿
            getDraft(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.learningDraft,
                    data: {},
                    success(res) {
                        if(res.data.technical_name!=null&&res.data.technical_name!=''){// 供应产品/服务/技术名称
                            that.name = res.data.technical_name 
                        }
                        if(res.data.patents!=null&&res.data.patents!=''){// 发明专利数量
                            that.invent = res.data.patents 
                        }
                        if(res.data.copyrights_name!=null&&res.data.copyrights_name!=''){// 著作权数量
                            that.copyright = res.data.copyrights_name 
                        }
                        if(res.data.utility_patents!=null&&res.data.utility_patents!=''){// 实用新型专利数量
                            that.practical = res.data.utility_patents 
                        }
                        if(res.data.other_patents!=null&&res.data.other_patents!=''){// 其它
                            that.other = res.data.other_patents 
                        }
                        if(res.data.logo!=null&&res.data.logo!=''){// 商标数量
                            that.brand = res.data.logo 
                        }
                        if(res.data.design_patent!=null&&res.data.design_patent!=''){// 外观专利数量
                            that.facade = res.data.design_patent 
                        }
                    }
                }) 
            },
            // 提交下一步
            onSubmit(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.learning,
                    data: {
                        technical_name:that.name,// 供应产品/服务/技术名称
                        patents:that.invent,// 发明专利数量
                        copyrights_name:that.copyright,// 著作权数量
                        utility_patents:that.practical,// 实用新型专利数量
                        other_patents:that.other,// 其它
                        logo:that.brand,// 商标数量
                        design_patent:that.facade,// 外观专利数量
                        type:1,
                    },
                    success(res) {
                        that.$dialog.toast({
                            mes: res.msg,
                            timeout: 1500,
                            icon: 'success',
                            callback(){
                                that.$router.push({ path: '/safety',query:{type:that.isType}})
                            }
                        })
                    }
                }) 
            },
            // 获取审批后详情
            getDetails(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.particulars,
                    data: {},
                    success(res) {
                        if(res.data.technical_name!=null&&res.data.technical_name!=''){// 供应产品/服务/技术名称
                            that.name = res.data.technical_name 
                        }
                        if(res.data.patents!=null&&res.data.patents!=''){// 发明专利数量
                            that.invent = res.data.patents 
                        }
                        if(res.data.copyrights_name!=null&&res.data.copyrights_name!=''){// 著作权数量
                            that.copyright = res.data.copyrights_name 
                        }
                        if(res.data.utility_patents!=null&&res.data.utility_patents!=''){// 实用新型专利数量
                            that.practical = res.data.utility_patents 
                        }
                        if(res.data.other_patents!=null&&res.data.other_patents!=''){// 其它
                            that.other = res.data.other_patents 
                        }
                        if(res.data.logo!=null&&res.data.logo!=''){// 商标数量
                            that.brand = res.data.logo 
                        }
                        if(res.data.design_patent!=null&&res.data.design_patent!=''){// 外观专利数量
                            that.facade = res.data.design_patent 
                        }
                    }
                })
            },
            // 用户信息
            getUser(){
                const that = this
                that.$request({
                    that: that,
                    api: that.$api.consumer,
                    data: {},
                    success(res) {
                       that.user = res.data
                    }
                })
            },
            // 退出
            onQuit(){
                const that = this
                //存储用户登录凭证
                that.$storage.remove('accesstoken')

                //登录成功发起页面跳转
                that.$dialog.toast({
                    mes: '退出登录成功',
                    timeout: 2000,
                    icon: 'success',
                    callback(){
                        that.$router.push({ path: '/logIn' })
                    }
                })
            },
            // 文档上传
            uploadFile(e){
                console.log('123+++',e.target.files)
                const that = this
                let inputDOM = that.$refs.inputer
                    that.fil = inputDOM.files
                    
                if(that.fil.length == 0) return 
                for(let i=0;i<that.fil.length;i++) {
                    that.uploadData(that.fil[i],i)
                }
            },
            // 上传
            uploadData(pdf,i){
                const that = this
                that.imgData = new FormData()
                // that.imgData.append('catalog','bourse')
                // 
                // that.imgData.append('name','images')
                that.imgData.append('type','1')
                that.imgData.append('file',pdf)
                that.imgData.append('id',that.user.id)
                console.log('*********1',that.imgData)
                that.$request({
                    that: that,
                    api: that.$api.putForms,
                    data: that.imgData,
                    headers: { 'content-type': 'multipart/form-data'},
                    discardSign: true,
                    loading: true,
                    success(res){
                        that.$dialog.toast({
                            mes: '上传成功',
                            timeout: 1500,
                            icon: 'success',
                        })
                        that.name = '',// 供应产品/服务/技术名称
                        that.invent = '',// 发明专利数量
                        that.copyright = '',// 著作权数量
                        that.practical = '',// 实用新型专利数量
                        that.other = '',// 其它
                        that.brand = '',// 商标数量
                        that.facade = '',// 外观专利数量
                        that.getDraft()
                        console.log('打印本次结果：',res)
                        // console.log('打印本次上传的图片路径：',res.data)
                        // that.supplier_info = res.data.src
                        // console.log('打印查看',that.atlas)
                    },
                    fail(err) {
                        console.log(err)
                        that.$dialog.alert({
                            mes:'上传失败'
                        });
                    }
                })
            },
        },
        mounted() {
            const that = this
            that.$store.commit('EditPageData',this.PageData)
            that.getUser()// 用户信息
            that.isType = that.$route.query.type
            if(that.$route.query.type==2){
                that.getDetails()// 获取审批后详情
            }else{
                that.getDraft()// 获取保存草稿
            }
        },
        components:{
            
        },
    }
</script>


// WEBPACK FOOTER //
// src/page/knowledge.vue